import React from 'react';
import { Event } from '../../../../../model/event';
import { Ticketcodes } from '../Overview/Ticketcodes/Ticketcodes';
import { Grid } from '../../../../../components/Grid/Grid';
import { CodeUsageUpload } from './CodeUsageUpload';
import { Card } from '../../../../../components/Card/Card';
import { LabelledProgress } from '../../../../../components/LabelledProgress/LabelledProgress';
import { t } from '../../../../../locales/translate';
import { ScannerNamesList } from './ScannerNames/ScannerNamesList';
import { ExternalCodesUpload } from './ExternalCodesUpload';
import { ScannerCodeTypes } from './ScannerCodeTypes';
import { formatNumber, formatPercentage } from '../../../../../util/util';
import { urlForPath } from '../../../../../routes';
import { Icon } from '../../../../../components/Icon/Icon';
import { Stack } from '../../../../../components/Stack/Stack';

export function Codes({ event }: { event: Event }): JSX.Element {
  const ticketTotal: number = (event.salesStats?.used || 0) + (event.salesStats?.unused || 0);
  return (
    <>
      <Card
        footer={
          <a href={urlForPath(`/connect2/admission-statistics/${event.secureId}`)} target="_blank" rel="noreferrer">
            <Stack line align="center" size="xxxs">
              {t.model.event.admissionStatisticsLink} <Icon name="external-link--sm" />
            </Stack>
          </a>
        }
      >
        <LabelledProgress
          values={[
            {
              value: event.salesStats?.used || 0,
              label: t.model.ticket.used,
              displayValue: event.salesStats?.unused
                ? `${formatNumber(event.salesStats?.used, 0)} (${formatPercentage(
                    event.salesStats?.used / ticketTotal,
                    {}
                  )})`
                : undefined,
            },
            {
              value: event.salesStats?.unused || 0,
              label: t.model.ticket.unused,
              displayValue: event.salesStats?.unused
                ? `${formatNumber(event.salesStats?.unused, 0)} (${formatPercentage(
                    event.salesStats?.unused / ticketTotal,
                    {}
                  )})`
                : undefined,
            },
          ]}
        />
      </Card>
      <Grid>
        <Ticketcodes event={event} />
        <CodeUsageUpload event={event} />
        <ScannerNamesList eventId={event.id} />
        <ExternalCodesUpload event={event} />
        <ScannerCodeTypes eventId={event.id} />
      </Grid>
    </>
  );
}
